import { createIntersectionObserver } from "@faire/web--source/ui/hooks/IntersectionObserverFactory";

const { IntersectionObserverProvider, usePairedIntersectionObserver } =
  createIntersectionObserver();

export { IntersectionObserverProvider, usePairedIntersectionObserver };
